import { useCallback, useMemo } from 'react'
import axios from 'axios'
import { useMutation } from '@tanstack/react-query'

import config from '../../config'

import {
  IGetPutRequest,
  IUseUpdateMutation,
  IUpdateFn,
  ISavedSearchFilterReminder,
  ISavedSearchFilterReminderUpdateUpsert,
} from '../../interfaces'

const getUpdateSavedSearchFilterReminderMutationRequest: IGetPutRequest = params => {
  const { airportId } = params

  return {
    method: 'put',
    url: `${config.baseUrl}/${airportId}/Reminders/SavedSearch`,
  }
}

const useUpdateSavedSearchFilterReminderMutation: IUseUpdateMutation<
  ISavedSearchFilterReminder,
  ISavedSearchFilterReminderUpdateUpsert
> = (params, options = {}) => {
  const request = useMemo(() => getUpdateSavedSearchFilterReminderMutationRequest(params), [params])

  const createSavedSearchFilterReminder: IUpdateFn<ISavedSearchFilterReminderUpdateUpsert, ISavedSearchFilterReminder> =
    useCallback(async data => axios({ ...request, data }).then(res => res.data), [request])

  const response = useMutation<ISavedSearchFilterReminder, Error, ISavedSearchFilterReminderUpdateUpsert>({
    mutationFn: createSavedSearchFilterReminder,
    ...options,
  })

  return response
}

export default useUpdateSavedSearchFilterReminderMutation
